import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removePopover, pushPopover } from './actionCreators';
import { getPopover } from './selectors';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import isEqual from 'lodash/isEqual';
export const usePopover = (id)=>{
    const dispatch = useDispatch();
    const popover = useSelector((state)=>getPopover(state, id), isEqual);
    return {
        popover,
        removePopover: useCallback(()=>yieldToMain(()=>dispatch(removePopover(id))), [
            id,
            dispatch
        ]),
        pushPopover: useCallback((options)=>dispatch(pushPopover(id, options)), [
            id,
            dispatch
        ]),
        togglePopover: useCallback(()=>{
            yieldToMain(()=>{
                if (popover.isOpen) {
                    dispatch(removePopover(id));
                } else {
                    dispatch(pushPopover(id));
                }
            });
        }, [
            id,
            dispatch,
            popover.isOpen
        ])
    };
};

//# sourceMappingURL=hooks.js.map